// Actions

export const FETCH_REGION_DETAILS = 'FETCH_REGION_DETAILS';
export const SET_REGION_DETAILS = 'SET_REGION_DETAILS';
export const FETCH_REGION_LIST = 'FETCH_REGION_LIST';
export const SET_REGION_LIST = 'SET_REGION_LIST';

const initialState = {
  list: [],
  details: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_REGION_DETAILS:
      return { ...state, details: { ...action.region } };
    case SET_REGION_LIST:
      return {
        ...state,
        list: action.list,
        totalEntries: action.totalEntries,
      };
    default:
      return state;
  }
}

export function fetchRegionDetails(id) {
  return { type: FETCH_REGION_DETAILS, id };
}

export function setRegionDetails(region) {
  return { type: SET_REGION_DETAILS, region };
}

export function fetchRegionList() {
  return { type: FETCH_REGION_LIST };
}
export function setRegionList(list, totalEntries = 0) {
  return { type: SET_REGION_LIST, list, totalEntries };
}

// selectors
export const getRegion = state => state.region.details;
export const getRegionCentreOfGravity = state =>
  state.region.details.centreOfGravity;
export const getRegionCurrency = state => state.region.details.currency;
export const getRegionList = state => state.region.list;
export const getNoOfRegion = state => state.region.totalEntries;
